module.exports = __webpack_public_path__ + "img/illustrations/mail-08a471ace850b8bf622e23416e60c54c.svg";